import "./SectionThree.css";

import React from "react";

import { Link } from "react-router-dom";

import { useState, useEffect } from "react";
import { SectionThreeSlider } from "./SentionThreeSlider";

export const SectionThree = ({ itemsData }) => {
  const [sliderItems1, setSliderItems1] = useState([]);
  const [sliderItems2, setSliderItems2] = useState([]);
  const [sliderItems3, setSliderItems3] = useState([]);
  const [sliderItems4, setSliderItems4] = useState([]);
  const [sliderItems, setSliderItems] = useState([]);

  // const [sliderSelection, setSliderSelection] = useState(0);
  // const handleChangeSliderSelectionAll = () => {
  //   setSliderSelection(0);
  //   setSliderItems(itemsData);
  // };
  // const handleChangeSliderSelection1 = () => {
  //   setSliderSelection(1);
  //   setSliderItems(sliderItems1);
  // };
  // const handleChangeSliderSelection2 = () => {
  //   setSliderSelection(2);
  //   setSliderItems(sliderItems2);
  // };
  // const handleChangeSliderSelection3 = () => {
  //   setSliderSelection(3);
  //   setSliderItems(sliderItems3);
  // };
  // const handleChangeSliderSelection4 = () => {
  //   setSliderSelection(4);
  //   setSliderItems(sliderItems4);
  // };
  const handleMoveToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    let allSliderItems = [];
    itemsData.map((item) => {
      if (item.isOnFrontPage === true) {
        allSliderItems.push(item);
        // item.category.map((category) => {
        //   if (category === "coffee") {
        //     setSliderItems1((old) => [...old, item]);
        //   }
        //   if (category === "green") {
        //     setSliderItems2((old) => [...old, item]);
        //   }
        //   if (category === "roasted") {
        //     setSliderItems3((old) => [...old, item]);
        //   }
        //   if (category === "italian") {
        //     setSliderItems4((old) => [...old, item]);
        //   }
        // });
      }
    });
    setSliderItems(allSliderItems);
  }, []);
  return (
    <div className="section-three-container">
      <h2 className="section-three-title2">Нови продукти и промоции</h2>
      {/* <div className="slider-menu">
        <p
          onClick={handleChangeSliderSelectionAll}
          style={{
            cursor: "pointer",
            borderBottom: sliderSelection === 0 ? "2px solid #c0aa83" : "none",
          }}
        >
          All
        </p>
        <p
          onClick={handleChangeSliderSelection1}
          style={{
            cursor: "pointer",
            borderBottom: sliderSelection === 1 ? "2px solid #c0aa83" : "none",
          }}
        >
          Coffee
        </p>
        <p
          onClick={handleChangeSliderSelection2}
          style={{
            cursor: "pointer",
            borderBottom: sliderSelection === 2 ? "2px solid #c0aa83" : "none",
          }}
        >
          Green Cofee
        </p>
        <p
          onClick={handleChangeSliderSelection3}
          style={{
            cursor: "pointer",
            borderBottom: sliderSelection === 3 ? "2px solid #c0aa83" : "none",
          }}
        >
          Roasted Cofee
        </p>
        <p
          onClick={handleChangeSliderSelection4}
          style={{
            cursor: "pointer",
            borderBottom: sliderSelection === 4 ? "2px solid #c0aa83" : "none",
          }}
        >
          Italian
        </p>
      </div> */}
      <SectionThreeSlider sliderItems={sliderItems} />
      <Link
        onClick={handleMoveToTop}
        to={"/shop"}
        className="section-three-bottom-button"
      >
        всички продукти
      </Link>
    </div>
  );
};
